// extracted by mini-css-extract-plugin
export default {"backButton":"RoomsOverview_backButton__qxaO8","linkContainer":"RoomsOverview_linkContainer__1ezDm","warningContainer":"RoomsOverview_warningContainer__TkFzY"};